import util from './util.js'

const currentDomain = window.location.hostname
const envConfigs = {
  development: 'https://hr-recruitment-integration-api-dev.chehejia.com/api/v1.0', // 本地开发环境
  test: 'https://hr-recruitment-integration-api-test.chehejia.com/api/v1.0', // 测试环境
  production: 'https://hr-recruitment-integration-api.lixiang.com/api/v1.0' // 生产环境
}
let pre
if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {
  // 如果是本地开发环境
  pre = envConfigs.development
} else if (currentDomain.includes('.test')) {
  // 如果是测试环境（域名中包含 .test）
  pre = envConfigs.test
} else {
  // 默认使用生产环境
  pre = envConfigs.production
}

var wenjuan = process.env.WENJUAN_HOST

// token 持久化（与 util.js 中 axios 拦截器共用 key）
const TOKEN_KEY = 'pre_token'
function saveTokenIfPresent (data) {
  try {
    if (data && data.token && window.localStorage) {
      window.localStorage.setItem(TOKEN_KEY, data.token)
    }
  } catch (e) { /* ignore */ }
}
// 包装 success 回调，自动保存 token
function wrapSuccess (success) {
  return function (data, meta, message) {
    saveTokenIfPresent(data)
    if (typeof success === 'function') {
      return success(data, meta, message)
    }
  }
}

// 预入职相关接口
export default {

  // 获取意向书
  getIntent (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + `/intent/info`, params, success, failure, httpFail)
  },
  // 接受意向书
  acceptIntent (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + `/intent/accept`, params, success, failure, httpFail)
  },
  // 拒绝意向书
  refuseIntent (params, success, failure, httpFail) {
    return util.httpPost(wenjuan + `/intent/refuse`, params, success, failure, httpFail)
  },
   // 预览意向书
  priveiwIntent (params, success, failure, httpFail) {
    return util.httpPost(wenjuan + `/intent/preview`, params, success, failure, httpFail)
  },
  // 放弃入职去向选项
  getWhereList (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + '/offer/setting/dict/GIVE_UP_TO_WHERE', params, success, failure, httpFail)
  },
  // 招聘放弃原因选项
  getGiveUpReasonList (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + '/offer/setting/dict/RECRUITMENT_GIVE_UP_REASON', params, success, failure, httpFail)
  },
  // 候选人拒绝offer选项
  getRefuseReasonList (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + '/offer/setting/dict/ONBOARD_REFUSE_REASON', params, success, failure, httpFail)
  },
  // 保存放弃入职
  saveGiveUp (params, success, failure, httpFail) {
    return util.httpPost(wenjuan + '/offer/giveup-offer', params, success, failure, httpFail)
  },
  // 保存拒绝offer
  saveRefuse (params, success, failure, httpFail) {
    return util.httpPost(wenjuan + '/offer/refuse-offer', params, success, failure, httpFail)
  },
       // 查看offer
  getOfferInfo (params, success, failure, httpFail) {
    return util.httpGet(wenjuan + `/offer/info`, params, success, failure, httpFail)
  },

  // 验证码验证（颁发 token）
  checkCode (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/check_code`, params, wrapSuccess(success), failure, httpFail)
  },

  // 确认offer
  confirmOffer (params, success, failure, httpFail) {
    return util.httpPost(wenjuan + `/offer/accept-offer`, params, success, failure, httpFail)
  },

  // 确认offer老的
  confirmOfferOld (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/confirm_offer`, params, success, failure, httpFail)
  },

  // 提交资料接口
  sendMaterial (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/send_material`, params, success, failure, httpFail)
  },

  // 获取资料接口
  getMaterial (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_material`, params, success, failure, httpFail)
  },

  // 获取预入职用户的所有信息
  getStaffDetail (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_staff_detail`, params, success, failure, httpFail)
  },

  // 校招人员入职确认
  campusRecruitmentConfirmation (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/campus_recruitment_confirmation`, params, success, failure, httpFail)
  },

  // 校招人员入职拒绝
  campusRecruitmentRefuse (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/campus_recruitment_refuse`, params, success, failure, httpFail)
  },

  // 校招人员获取放弃原因
  campusRecruitmentArchiveReasons (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/campus_recruitment/archive_reasons`, params, success, failure, httpFail)
  },

  // 获取教育经历、家庭情况、工作经历、培训经历
  getExperience (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_experience`, params, success, failure, httpFail)
  },

  // 保存拒绝Offer信息
  schoolRefuse (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/school_refuse`, params, success, failure, httpFail)
  },

  // 更新教育经历、家庭情况、工作经历、培训经历
  saveExperience (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/save_experience`, params, success, failure, httpFail)
  },

  // 获取用户发展计划
  getPlan (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_plan`, params, success, failure, httpFail)
  },

  // 更新用户发展计划
  savePlan (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/save_plan`, params, success, failure, httpFail)
  },

  // 获取补充信息
  getSupplement (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_supplement`, params, success, failure, httpFail)
  },

  // 更新补充信息
  saveSupplement (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/save_supplement`, params, success, failure, httpFail)
  },

  // 生成offer
  createOfferPDF (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/create_offer_pdf`, params, success, failure, httpFail)
  },

  // 更新Material单个字段的值
  updateMaterialByField (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/update_material_by_field`, params, success, failure, httpFail)
  },

  // 获取area
  getArea (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_area`, params, success, failure, httpFail)
  },

  // 获取大学名称
  getSchool (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_school`, params, success, failure, httpFail)
  },

  // 获取一个用户所有的录入信息，根据用户ID
  getUserInfo (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_userinfo`, params, success, failure, httpFail)
  },

  // 验证入职必备
  changeCertifyStatus (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/change_certify_status`, params, success, failure, httpFail)
  },

  // 验证证件材料
  changeUploadStatus (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/change_upload_status`, params, success, failure, httpFail)
  },

  // 获取状态字段
  getStatusValue (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_status_value`, params, success, failure, httpFail)
  },

  // 更新状态字段
  updateStatusValue (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/update_status_value`, params, success, failure, httpFail)
  },

  // 更新提交时间字段
  updateSubmitAt (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/update_submit_at`, params, success, failure, httpFail)
  },

  // 验证是否登录（成功后刷新 token）
  checkLogin (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/check_login`, params, wrapSuccess(success), failure, httpFail)
  },

  // 下载offer
  downloadOffer (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/download_offer`, params, success, failure, httpFail)
  },

  // 校验后台预览offer接口（颁发 admin token）
  checkPreLogin (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/check_pre_login`, params, wrapSuccess(success), failure, httpFail)
  },

  // 验证ID
  checkID (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/check_id`, params, success, failure, httpFail)
  },

  // 获取正式提交状态及入职必备资料的审核状态
  getSubmitStatus (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_submit_status`, params, success, failure, httpFail)
  },

  // 获取正式提交状态及入职必备资料的审核状态
  getAreaByName (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_area_by_name`, params, success, failure, httpFail)
  },

  // 获取offer短信模板内容
  getOfferTemplateData (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_offer_template_data`, params, success, failure, httpFail)
  },

  // 获取所有城市信息 redis
  getCityInfoOfRedis (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/get_city_info_of_redis`, params, success, failure, httpFail)
  },
  // 保存隐私授权信息
  savePrivacy (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/save_privacy_auth`, params, success, failure, httpFail)
  },
  // 银行卡识别
  toResolveBankCard (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/upload_material/${params.id}/bank_card_url`, params.file, success, failure, httpFail)
  },
  // 删除银行卡信息
  toDelBankCard (params, success, failure, httpFail) {
    return util.httpGet(pre + `/onboard/del_ocr_bank_card`, params, success, failure, httpFail)
  },
  // 获取页面码值选项
  postPsOption (params, success, failure, httpFail) {
    return util.httpPost(pre + `/onboard/post_ps_option`, params, success, failure, httpFail)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/preentry.js